import React, { FC } from 'react';
import SectionMessage from '@atlaskit/section-message';

import ExternalLinkAction from '@/components/primitive/external-link';
import { DAC_TROUBLESHOOTING_DOC_LINK } from '@/constants';

/**
 * SFx sum(by=... warning
 * @see https://hello.atlassian.net/browse/TOME-1574
 */
const QueryUnfilledWarning: FC = () => (
  <SectionMessage appearance="warning">
    Adding a <b>.sum()</b> after your .sum(by=...) function in SignalFlow query could resolve the
    problem.
    <p>
      <ExternalLinkAction
        text="Find out the details on our doc"
        href={`${DAC_TROUBLESHOOTING_DOC_LINK}#data-points-error-due-to-using-sum-by-----function`}
      />
    </p>
  </SectionMessage>
);

export default QueryUnfilledWarning;
